import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LeagueSidebar from "./LeagueSidebar";
import { Col, Container, Row } from "react-bootstrap";
import { scrollToTop } from "../../lib/utils";

const LeaguesLayout = (): React.JSX.Element => {
    const location = useLocation();
    const leaguesPathMatch = /leagues/.test(location.pathname);
    const playoffsPathMatch = /playoffs/.test(location.pathname);

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    return (
        <Container
            className="py-2 py-lg-5 leagues"
            data-testid="leaguesContent"
        >
            {leaguesPathMatch ? (
                <Row>
                    <Col
                        xl={playoffsPathMatch ? 2 : undefined}
                        lg={!playoffsPathMatch ? 2 : undefined}
                    >
                        <LeagueSidebar />
                    </Col>
                    <Col>
                        <Outlet />
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col>
                        <Outlet />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default LeaguesLayout;
